'use strict';

const { buildCustomerConfigScreenView } = require('./CustomerConfigScreen-View.js');

/**
 * The customer configuration screens built on CustomerConfigScreen: each one's provider, view, route and title.
 * The application registers them all from here. The router names each Route explicitly, as it does every route
 * (web/lims's manifest test reads them from its source).
 *
 * @type {Array<{ Route: string, Provider: any, ViewIdentifier: string, View: any, ViewConfiguration: Record<string, any> }>}
 */
const SCREENS =
[
	{
		Route: '/SampleScanningConfig',
		Provider: require('./SampleScanningConfig-Provider.js'),
		ViewIdentifier: 'SampleScanningConfig-View',
		MountID: 'SSC-Detail',
		Title: 'Sample Scanning',
		Subtitle: 'What scanning a sample label does: whether Fieldbook on iPad offers its scanner, and the status a sample takes when it is scanned into a location.',
	},
	{
		Route: '/FormAccess',
		Provider: require('./FormAccessConfig-Provider.js'),
		ViewIdentifier: 'FormAccessConfig-View',
		MountID: 'FAC-Detail',
		Title: 'Who Can Open New Forms',
		Subtitle: 'For each type of form, the roles that can open and edit a new one as soon as it is created, on any project.',
	},
	{
		Route: '/FieldbookDashboards',
		Provider: require('./FieldbookDashboardsConfig-Provider.js'),
		ViewIdentifier: 'FieldbookDashboardsConfig-View',
		MountID: 'FDC-Detail',
		Title: 'Fieldbook Dashboards',
		Subtitle: 'The classic dashboards this customer’s projects offer in Fieldbook, on the web and on iPad.',
	},
].map((pScreen) =>
{
	const tmpBuilt = buildCustomerConfigScreenView(
		{
			ViewIdentifier: pScreen.ViewIdentifier,
			ProviderHash: pScreen.Provider.SCREEN.Hash,
			MountID: pScreen.MountID,
			Title: pScreen.Title,
			Subtitle: pScreen.Subtitle,
		});
	if (`#${pScreen.MountID}` !== pScreen.Provider.SCREEN.Mount)
	{
		throw new Error(`${pScreen.Provider.SCREEN.Hash}: its mount ${pScreen.Provider.SCREEN.Mount} is not the view's #${pScreen.MountID}`);
	}
	return { Route: pScreen.Route, Provider: pScreen.Provider, ViewIdentifier: pScreen.ViewIdentifier, View: tmpBuilt.View, ViewConfiguration: tmpBuilt.default_configuration };
});

/**
 * Register every screen's provider and view.
 *
 * @param {any} pPict
 */
function registerConfigScreens(pPict)
{
	SCREENS.forEach((pScreen) =>
	{
		pPict.addProvider(pScreen.Provider.SCREEN.Hash, pScreen.Provider.default_configuration, pScreen.Provider);
		pPict.addView(pScreen.ViewIdentifier, pScreen.ViewConfiguration, pScreen.View);
	});
}

module.exports = { SCREENS, registerConfigScreens };
